// 导入组件，组件必须声明 name
import videoBack from "./src/videoBack.vue";

videoBack.install = function(Vue) {
  Vue.component(videoBack.name, videoBack);
};

export default videoBack;
